import * as InputPrimitive from '@givebutter/primitives/input';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { CopyButton as CopyButtonPrimitive, CopyButtonProps } from 'components/copy-button';
import { CurrencySymbol } from 'customHooks/useCurrencySymbol';
import { twMerge } from 'tailwind-merge';

const InputRoot = InputPrimitive.Root;
const InputForm = InputPrimitive.Form;
const InputInteractable = InputPrimitive.Interactable;
const InputSingleSelectTrigger = InputPrimitive.SingleSelectTrigger;
const InputSearchIcon = ({ className, ...props }: Omit<FontAwesomeIconProps, 'icon'>) => (
    <FontAwesomeIcon className={twMerge('text-gray-300', className)} icon={faSearch} {...props} />
);
const InputCurrencyIcon = () => <CurrencySymbol />;
const InputCopyButton = (props: CopyButtonProps) => (
    <InputInteractable>
        <CopyButtonPrimitive {...props} />
    </InputInteractable>
);

const Root = InputRoot;
const Form = InputForm;
const Interactable = InputInteractable;
const SingleSelectTrigger = InputSingleSelectTrigger;
const SearchIcon = InputSearchIcon;
const CurrencyIcon = InputCurrencyIcon;
const CopyButton = InputCopyButton;

export {
    InputInteractable,
    InputRoot,
    InputForm,
    InputSingleSelectTrigger,
    InputSearchIcon,
    InputCurrencyIcon,
    InputCopyButton,
    //
    Root,
    Form,
    Interactable,
    SingleSelectTrigger,
    SearchIcon,
    CurrencyIcon,
    CopyButton,
};
